module.exports = __webpack_public_path__ + "b3f385f4.png";